<template>
  <b-modal v-model="show" centered title="Statuses Info" hide-footer>
    <div class="d-block mx-2">
      <p>
        <strong>Report Status</strong> is the main status of the report within the system, and it is visible to users in
        the apps.
      </p>

      <p>There are three levels of report handling:</p>
      <ol>
        <li>
          <strong>System</strong>: Automatically processes the report based on predefined rules. It can approve,
          decline, or forward the report to the next level.
        </li>
        <li>
          <strong>AI Validation</strong>: Uses GPT API prompts to analyze the report. AI may either skip the report to
          the next level or confidently approve/decline it.
        </li>
        <li><strong>Human</strong>: Manual review of the report within the admin panel.</li>
      </ol>

      <p>At each level, the system sets the following fields:</p>
      <ul>
        <li><strong>Processing Status</strong>: Indicates the report's processing outcome at the current level.</li>
        <li>
          <strong>Processed By</strong>: Identifies the reviewer (system, AI, or human) who last handled the report.
        </li>
        <li>
          <strong>Assigned To</strong>: Specifies the next reviewer (if a decision hasn't yet been made). If the report
          is approved or declined, this is set to <code>None</code>.
        </li>
      </ul>

      <p>
        <strong>Provider Status</strong> reflects the state of the report on the provider's side. It's independent from
        internal statuses and only applies when a refund request is sent to the provider, who may then approve or
        decline it.
      </p>

      <p>
        A complete <strong>processing history</strong> of the report is available and can be viewed in the "View Report"
        modal.
      </p>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    showStatusInfoModal: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      show: false
    }
  },
  watch: {
    showStatusInfoModal() {
      this.show = this.$props.showStatusInfoModal
    },
    show(val) {
      if (!val) this.$emit('closeStatusInfoModal')
    }
  }
}
</script>
